import { INGXLoggerMetadata, NgxLoggerLevel } from "ngx-logger";

/**
 * Ispisuje log u browser konzolu kao NORMALNU poruku, rutiranu po nivou:
 * greške → console.error (crveno, sa stack trace-om ako je Error u `additional`),
 * upozorenja → console.warn, info/log → console.info, trace/debug → console.debug.
 *
 * Ovo zamenjuje ranije `console.log(metadata)` koje je dampovalo ceo metadata objekat
 * (pa je konzola bila puna ngx-logger "šuma"). Snimanje u bazu/na server radi ostaje
 * netaknuto u samom writer-u — ova funkcija je SAMO za prikaz u konzoli.
 */
export function writeToConsole(metadata: INGXLoggerMetadata): void {
  const args = [metadata.message, ...(metadata.additional ?? [])];

  switch (metadata.level) {
    case NgxLoggerLevel.FATAL:
    case NgxLoggerLevel.ERROR:
      console.error(...args);
      break;
    case NgxLoggerLevel.WARN:
      console.warn(...args);
      break;
    case NgxLoggerLevel.INFO:
    case NgxLoggerLevel.LOG:
      console.info(...args);
      break;
    default: // TRACE, DEBUG
      console.debug(...args);
      break;
  }
}
